import React, { useEffect, useState } from "react";
import SideBar from "../common/SideBar";
import AuthGuard from "../../guards/AuthGuard";
import NavBar from "../common/NavBar";
import { Outlet, useNavigate } from "react-router-dom";
import { MenuItems, menuItems } from "../../data/MenuItems";
import { useSelector } from "react-redux";
import { RootState } from "../../redux/store";
import { adminMenuItems } from "../../data/AdminMenuItems";
import KycGuard from "../../guards/KycGuard";
import { AuthService } from "../../services/authService";
import { usePermission } from "../../hooks/usePermission";

type DashboardLayoutProps = {};

const DashboardLayout: React.FC<DashboardLayoutProps> = () => {
  const [isSidebarExpanded, setSidebarExpanded] = useState(true);
  const [sideBarItems, setSideBarItems] = useState<MenuItems[]>([]);
  const navigate = useNavigate();
  const { currentUser, loading } = useSelector(
    (state: RootState) => state.auth
  );
  const { hasPermission } = usePermission();

  const silentLogout = async () => {
    navigate("/auth", { replace: true });
  };

  useEffect(() => {
    if (!loading) {
      const roleCode = currentUser?.role?.role_code;
      if (!roleCode) {
        setSideBarItems([]);
        return;
      }

      const baseMenu =
        roleCode === "CUSTOMER" || roleCode === "ENTERPRISE"
          ? menuItems
          : adminMenuItems;

      const filteredMenu = baseMenu.filter((item) => {
        if (item.requiredPermission) {
          return hasPermission(item.requiredPermission);
        }
        return !item.allowedRoles || item.allowedRoles.includes(roleCode);
      });

      setSideBarItems(filteredMenu);
    }
  }, [currentUser?.role?.role_code, currentUser?.role?.permissions, loading]);

  return (
    <AuthGuard>
      <KycGuard>
        <div className="flex">
          <SideBar
            menuItems={sideBarItems}
            isExpanded={isSidebarExpanded}
            setIsExpanded={setSidebarExpanded}
          />
          <main
            className={`dashboard-main w-full flex-1 transition-all duration-300 ${isSidebarExpanded ? "md:ml-64" : "md:ml-24"}`}
          >
            <NavBar
              isExpanded={isSidebarExpanded}
              setIsExpanded={setSidebarExpanded}
            />

            <div className="dashboard-main-body p-6">
              <Outlet />
            </div>
          </main>
        </div>
      </KycGuard>
    </AuthGuard>
  );
};

export default DashboardLayout;
